export const isFavoriteByVehicleId = state => vehicleId => {
  return state.vehicles.find(vehicle => vehicle.id === vehicleId) !== undefined
}

export default {
  isFavoriteByVehicleId
}
